<div>
  <div
    class="img-container"
    [ngClass]="{ 'img-container-with-image': backgroundImage }"
    [style.background-image]="
      'url(data:image/png;base64,' + backgroundImage + ')'
    "
  >
  <ng-container>
    <iframe
     *ngIf="backgroundImage && isImagemAnexadaPdf" [src]="('data:application/pdf;base64,' + backgroundImage) | safeUrl " height="100%" width="100%">
    </iframe>
  </ng-container>

  <div class="captura" (click)="openCapture()" *ngIf="!isImagemAnexadaPdf">
    <div *ngIf="!hasImage && !captureOpen" class="img-container-label">
      <p>Capturar</p>
      <p>{{ sideName }}</p>
    </div>

    <div *ngIf="!inputLoaded && captureOpen" class="img-container-label">
      <mat-spinner [diameter]="30"></mat-spinner>
      <p>Carregando...</p>
    </div>

  </div>

  <div class="anexo" (click)="anexarCaptura()" *ngIf="permiteAnexo && (!hasImage && !captureOpen)">
    <input #inputUploadArquivo type="file" style="display: none" (change)="onUploadFile($event)">
    <div *ngIf="!hasImage && !captureOpen" class="img-container-label">
      <p>Anexar</p>
    </div>
  </div>

  <button
  class="img-container-remove-btn"
  *ngIf="hasImage"
  (click)="removeImage($event)"
>
  <img src="assets/icons/trash.svg" class="img-container-remove-btn-img" />
</button>

  <ng-template [ngIf]="!hideSideName">
    <div class="title" *ngIf="hasImage">{{ sideName }}</div>
  </ng-template>

  </div>
    

  <ng-container [ngSwitch]="parametroCameraIntegrada">
    <ng-container *ngSwitchCase="'unico'">
      <app-image-capture-unico
      *ngIf="captureOpen"
      [exibirTelaCaptura]="captureOpen && (!isSelf)"
      [isSelf]="isSelf"
      [campo]="field"
      (isLoading)="onLoaded($event)"
      (imageCapture)="onImageCapture($event)"
      (captureError)="onErrorCapture($event)"
      (patchFormValue)="onPatchValue($event)"
      ></app-image-capture-unico>
    </ng-container>
    <ng-container *ngSwitchCase="'fortface'">
      <app-image-capture-fortface
      *ngIf="isSelf && captureOpen"
      [exibirTelaCaptura]="captureOpen && (!isSelf)"
      [isSelf]="isSelf"
      [campo]="field"
      (isLoading)="onLoaded($event)"
      (imageCapture)="handleFortfaceCapture($event)"
      (captureError)="onErrorCapture($event)"
      ></app-image-capture-fortface>
      <app-image-capture-fortface-document
      *ngIf="(!isSelf) && captureOpen && usarFortfaceParaDocumento"
      class="image-capture"
      [campo]="field"
      (isLoading)="onLoaded($event)"
      (imageCapture)="handleFortfaceCaptureDocument($event)"
      (captureError)="onErrorCapture($event)">
      </app-image-capture-fortface-document>
      <app-image-capture
      *ngIf="(!isSelf) && captureOpen && !usarFortfaceParaDocumento"
      class="image-capture"
      (cancel)="onCancel($event)"
      (imageCapture)="onImageCapture($event)">
      </app-image-capture>
    </ng-container>
    <ng-container *ngSwitchCase="'oiti'">
      <app-image-capture-oiti
      *ngIf="isSelf && captureOpen"
      (imageCapture)="onImageCapture($event)"
      (captureError)="onErrorCapture($event)"
      ></app-image-capture-oiti>
      <app-image-capture-oiti-document
      *ngIf="(!isSelf) && captureOpen"
      [campo]="field"
      (imageCapture)="onMultipleImageCapture($event)"
      (captureError)="onErrorCapture($event)"
      (cancel)="onCancel($event)"
      ></app-image-capture-oiti-document>
    </ng-container>
    <!-- TODO 
        oiti
        vsoft
      -->
    
    <ng-container 
    *ngSwitchCase="'vsoft'">
      <app-image-capture-vsoft
      *ngIf="captureOpen"
      class="image-capture"
      (cancel)="onCancel($event)"
      (imageCapture)="onImageCapture($event)"
      (captureError)="onErrorCapture($event)"
      ></app-image-capture-vsoft>
      
      <app-image-capture
      *ngIf="(!isSelf) && captureOpen"
      class="image-capture"
      (cancel)="onCancel($event)"
      (imageCapture)="onImageCapture($event)">
      </app-image-capture>
    </ng-container>

    <ng-container *ngSwitchCase="'serasa'">
      <app-image-capture-serasa
      *ngIf="captureOpen"
      class="image-capture"
      (cancel)="onCancel($event)"
      (imageCapture)="onImageCapture($event)"
      (captureError)="onErrorCapture($event)"
      ></app-image-capture-serasa>
      
      <app-image-capture
      *ngIf="(!isSelf) && captureOpen"
      class="image-capture"
      (cancel)="onCancel($event)"
      (imageCapture)="onImageCapture($event)">
      </app-image-capture>
    </ng-container>

    <ng-container *ngSwitchCase="'serasa-unificado-liveness'">
      <app-image-capture-serasa-unificado-liveness
      *ngIf="isSelf && captureOpen"
      [isSelf]="isSelf"
      (isLoading)="onLoaded($event)"
      (imageCapture)="handleSerasaUnificadoLivenessCapture($event)"
      (captureError)="onErrorCapture($event)"
      ></app-image-capture-serasa-unificado-liveness>
      <app-image-capture
      *ngIf="(!isSelf) && captureOpen"
      class="image-capture"
      (cancel)="onCancel($event)"
      (imageCapture)="onImageCapture($event)">
      </app-image-capture>
    </ng-container>
    
    <ng-container  *ngSwitchCase="'default'">
      <app-image-capture
      *ngIf="captureOpen"
      [isSelf]="isSelf"
      class="image-capture"
      (cancel)="onCancel($event)"
      (imageCapture)="onImageCapture($event)">
      </app-image-capture>
    </ng-container>
 
  </ng-container>
</div>
